// extracted by mini-css-extract-plugin
module.exports = {"scrollableContainer":"kbqOC9gz","tooltipWrapper":"HIocygDL","rightWrapper":"YIemI53G","titleLabel":"caovwP9Q","categoryLabel":"fxqo4qTQ"};